export const sanitizeString = (value) => {
  return value.replace(/\D/g, '');
};

export default sanitizeString;
